
import SigninUseCase from '@/modules/auth/usecases/signin.usecase'
import { ISignin, LanguageLocale, LocalizationPath, UserType } from '@tokyojob/core'
import { CAlertModal, ErrorModalFactory, getLocalization, IAlertModalProps, RouterLinkFactory } from '@tokyojob/frontend-components'
import { AgentLoginMetaFactory, IHead, LocalizationService } from '@tokyojob/frontend-core'
import Vue from 'vue'
import AgentLoginForm from '~/modules/auth/components/agent/agent-login-form.component.vue'
import CAlertModalBodyGeneric from '~/modules/vacancy/components/error-alert-modal-body/c-alert-modal-body-generic.vue'

const language = LanguageLocale.JAjp
const loginErrorTitle = 'ログインエラー'
const alertModalProps = ErrorModalFactory.AlertTitle(loginErrorTitle)
const alertBodyText = 'メールアドレス、パスワードをご確認の上、再度お試しください'

interface IData {
  /**
   * If error modal is displayed
   */
  alertModalDisplay: boolean
  /**
   * Props for text and css of alert modal
   */
  alertModalProps: IAlertModalProps
  /**
   * Language used for alert modal
   */
  language: LanguageLocale
  /**
   * Text used in alert modal body
   */
  alertBodyText: string
}

export default Vue.extend({
  layout: 'agent/auth',
  components: { AgentLoginForm, CAlertModal, CAlertModalBodyGeneric },
  data(): IData {
    return {
      alertModalDisplay: false,
      alertModalProps,
      language,
      alertBodyText
    }
  },
  methods: {
    /**
     * Check usertype and send user to appropriate page
     */
    async submit(props: ISignin) {
      const usecase = new SigninUseCase(this.App)
      const result = await usecase.execute(props)

      if (result != null) {
        switch (result.userType) {
          case UserType.Agent:
            window.location.href = '/agent'
            break
          case UserType.Admin:
            this.$router.push('/admin')
            break
          default:
            const link = RouterLinkFactory.localizedLink(
              '/',
              this.App.localizationSelector.language
            )
            this.$router.push(link)
            break
        }
      } else {
        this.alertModalDisplay = true
      }
    },
    /**
     * CLose the error modal
     */
    closeAlertModal() {
      this.alertModalDisplay = false
    }
  },
  head(): IHead {
    const localization = getLocalization(this.App)
    const title = LocalizationService.t<string>(localization, LocalizationPath.AgentLoginPageMetaTagTitle)
    const meta = AgentLoginMetaFactory.metaTags(localization, this.App.localizationSelector.languageLocale)
    return { title, meta }
  }
})
